import { CommApiInstance } from "Utils/CommApiInstance";




const IsMntnInqApi = async (
    gameSvcCd:string
) => {
    return await CommApiInstance.post(`${gameSvcCd}/mntn/is_mntn`,{
        apiBody:"",
    })
    .then((Resp) => Resp.data);
}
export default IsMntnInqApi;